import React from "react";
import { Redirect } from "react-router-dom";
import ChoosePanel from "../pages/package/package";
import Payment from "../pages/package/payment";
import ExtraPondPayment from "../pages/package/extraPondPayment";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
    "pk_live_51TcWrnEFp6E1oRogJ6ul5KZwwOONiiQlsq1WfQiz6KFzwtF6k4ktPHC1ykVZiWZd67Wl2S9UA71VlHxMEJBddZmL00RkevipOk"
);
const SubExpirePanel = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/package" />,
  },
  {
    path: "/package",
    exact: true,
    title: "Package",
    component: () => <ChoosePanel />,
  },
  {
    path: "/payment/extra-pond",
    exact: true,
    title: "Extra Pond Payment",
    component: () => (
      <Elements stripe={stripePromise}>
        <ExtraPondPayment />
      </Elements>
    ),
  },
  {
    path: "/payment/:id",
    exact: true,
    title: "Payment",
    component: ({ match }) => {
      return (
        <Elements stripe={stripePromise}>
          <Payment id={match.params.id} />
        </Elements>
      );
    },
  },
  {
      path: "*",
      component: ({ location }) => {
        const path = location.pathname;
        if (path.includes("/payment/")) {
          return null;
        }
        return <Redirect to="/package" />;
      },
    },
  
];

export default SubExpirePanel;
